export enum ZodiacTypes {
  AQUARIUS = 'aquarius',
  ARIES = 'aries',
  CANCER = 'cancer',
  CAPRICORN = 'capricorn',
  GEMINI = 'gemini',
  LEO = 'leo',
  LIBRA = 'libra',
  PISCES = 'pisces',
  SAGITTARIUS = 'sagittarius',
  SCORPIO = 'scorpio',
  TAURUS = 'taurus',
  VIRGO = 'virgo',
}

export enum ChineseZodiacTypes {
  RAT = 'rat',
  OX = 'ox',
  TIGER = 'tiger',
  RABBIT = 'rabbit',
  DRAGON = 'dragon',
  SNAKE = 'snake',
  HORSE = 'horse',
  GOAT = 'goat',
  MONKEY = 'monkey',
  ROOSTER = 'rooster',
  DOG = 'dog',
  PIG = 'pig',
}
